import type { SearchEntity, SearchGroup, SearchHit } from '../types/search';

const SALES_TRANSACTION_ENTITIES: SearchEntity[] = ['invoice', 'customer_payment'];
const PURCHASE_TRANSACTION_ENTITIES: SearchEntity[] = ['bill', 'bill_payment'];

export function mapSearchHitRoute(hit: SearchHit): string {
  const { entity, id } = hit;
  switch (entity) {
    case 'customer':
      return `/sales-transactions?customer=${id}`;
    case 'vendor':
      return `/purchase-transactions?vendor=${id}`;
    case 'invoice':
      return `/sales-transactions/view/invoice/${id}`;
    case 'bill':
      return `/purchase-transactions/view/bill/${id}`;
    case 'customer_payment':
      return `/sales-transactions/view/payment/${id}`;
    case 'bill_payment':
      return `/purchase-transactions/view/payment/${id}`;
    case 'item':
      return `/products?q=${encodeURIComponent(hit.title)}`;
    default:
      return '/';
  }
}

function isPurchaseOnlyTransactionGroup(group: SearchGroup): boolean {
  if (group.items.length === 0) return false;
  return group.items.every((hit) => PURCHASE_TRANSACTION_ENTITIES.includes(hit.entity));
}

function isSalesOnlyTransactionGroup(group: SearchGroup): boolean {
  if (group.items.length === 0) return false;
  return group.items.every((hit) => SALES_TRANSACTION_ENTITIES.includes(hit.entity));
}

export function seeAllGroupRoute(group: SearchGroup, q: string): string {
  const encoded = encodeURIComponent(q);
  switch (group.type) {
    case 'contacts':
      return `/customers?q=${encoded}`;
    case 'items':
      return `/products?q=${encoded}`;
    case 'transactions':
      if (isPurchaseOnlyTransactionGroup(group) && !isSalesOnlyTransactionGroup(group)) {
        return `/purchase-transactions?q=${encoded}`;
      }
      return `/sales-transactions?q=${encoded}`;
    default:
      return '/';
  }
}

export function defaultSearchFallbackRoute(q: string): string {
  return `/sales-transactions?q=${encodeURIComponent(q)}`;
}
